import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=1cf98d3f&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cf98d3f')) {
      api.createRecord('1cf98d3f', component.options)
    } else {
      api.reload('1cf98d3f', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=1cf98d3f&", function () {
      api.rerender('1cf98d3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iBD7Wmt8UMNZ/JS/offershelp.vue"
export default component.exports